import React from "react";

const Contact = () => {
    return (
        <>
            This is Contact Page
        </>
    );
};

export default Contact;
